module.exports = __webpack_public_path__ + "img/post_sample_google_biz.e6cf0b82.png";